import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appScrollVisibility]'
})
export class ScrollVisibilityDirective {
  private scrollTimeout: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    // Inicializa el contenedor con la barra oculta
    this.renderer.addClass(this.el.nativeElement, 'scroll-inactive');
  }

  @HostListener('scroll') onScroll() {
    // Añade la clase para hacer visible la barra de desplazamiento
    this.renderer.removeClass(this.el.nativeElement, 'scroll-inactive');
    this.renderer.addClass(this.el.nativeElement, 'scroll-active');
    
    // Después de un tiempo sin hacer scroll, ocultamos la barra de desplazamiento
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.renderer.removeClass(this.el.nativeElement, 'scroll-active');
      this.renderer.addClass(this.el.nativeElement, 'scroll-inactive');
    }, 1000);  // 1000ms = 1 segundo sin desplazamiento
  }
}
